/* eslint-disable import/prefer-default-export */

export const formatDecimal = ({ value, min, max, locale, defaultValue = 0 }) => {
  if (!value) {
    return defaultValue
  }
  return value.toLocaleString(locale, { minimumFractionDigits: min, maximumFractionDigits: max })
}
